import { Form } from 'react-bootstrap';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux/store';
import ScriptEditor from '../ui/ScriptEditor';
import { fetchSqlPlusUsernames } from '../../../../../../../redux/slices/connectionsSlice';
import { RootState } from '../../../../../../../redux/store';

const SqlPlus = ({ state, onChange, readOnly = false }: any) => {
  const { script, run_as_user, database_user, connection_alias, nr_of_lines_to_load } = state.config || {};

  const dispatch = useAppDispatch();
  const usernames = useSelector((state: RootState) => state.connections.sqlPlusUsernames);
  const loading = useSelector((state: RootState) => state.connections.loading.fetchSqlPlusUsernames);

  useEffect(() => {
    dispatch(fetchSqlPlusUsernames() as any);
  }, [dispatch]);

  return (
    <>
      <Form.Group className="mb-2 w-full" controlId="formNode-run_as_user">
        <Form.Label>Run as user</Form.Label>
        <Form.Control type="text" name="run_as_user" value={run_as_user || ''} onChange={(e) => onChange(e, true)} disabled={readOnly} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-database_user">
        <Form.Label>Database user</Form.Label>
        <Form.Select name="database_user" value={database_user || ''} onChange={(e) => onChange(e, true)} disabled={loading || readOnly}>
          <option value="">Select a User</option>
          {usernames.map((username) => (
            <option key={username} value={username}>
              {username}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-connection_alias">
        <Form.Label>Connection alias</Form.Label>
        <Form.Control
          type="text"
          name="connection_alias"
          value={connection_alias || ''}
          onChange={(e) => onChange(e, true)}
          placeholder="e.g. PROD_DB"
          disabled={readOnly}
        />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-nr_of_lines_to_load">
        <Form.Label>Number of lines to load</Form.Label>
        <Form.Control type="text" name="nr_of_lines_to_load" value={nr_of_lines_to_load || ''} onChange={(e) => onChange(e, true)} disabled={readOnly} />
      </Form.Group>

      <ScriptEditor
        label="Script"
        controlId="formNode-script"
        name="script"
        value={script || ''}
        language="sql"
        onChange={(e) => onChange(e, true)}
        readOnly={readOnly}
        aria-label="Script editor"
      />
    </>
  );
};

export default SqlPlus;
